import React from "react";
import FormText from "./form/formText.component";
import { useDispatch, useSelector } from "react-redux";
import { stateProps } from "../types";
import { enterDegree } from "../actions/index";
import ContainerBox from "./common/containerBox.component";
import FormSingleInput from "./form/formSingleInput.component";

const Degree: React.FC = () => {
  const dispatch = useDispatch();

  const degree = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.degree
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterDegree(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText
          number={"07"}
          title={"Where did you obtain your medical degree?"}
        />
        <FormSingleInput
          value={degree}
          placeholder={"Your medical school"}
          onInputChange={onInputChange}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Degree;
